import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const adminData = localStorage.getItem('adminData');
    const candidateData = localStorage.getItem('candidateData');
    if (adminData) setAdmin(JSON.parse(adminData));
    if (candidateData) setCandidate(JSON.parse(candidateData));
    setLoading(false);
  }, []);

  const adminLogin = async (email, password) => {
    const res = await API.post('/admin/login', { email, password });
    localStorage.setItem('adminToken', res.data.token);
    localStorage.setItem('adminData', JSON.stringify(res.data.admin));
    setAdmin(res.data.admin);
    return res.data;
  };

  const adminRegister = async (fullName, email, password) => {
    const res = await API.post('/admin/register', { fullName, email, password });
    localStorage.setItem('adminToken', res.data.token);
    localStorage.setItem('adminData', JSON.stringify(res.data.admin));
    setAdmin(res.data.admin);
    return res.data;
  };

  const adminLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    setAdmin(null);
  };

  const candidateLogin = async (password) => {
    const res = await API.post('/candidates/login', { password });
    localStorage.setItem('candidateToken', res.data.token);
    localStorage.setItem('candidateData', JSON.stringify(res.data.candidate));
    setCandidate(res.data.candidate);
    return res.data;
  };

  const candidateLogout = () => {
    localStorage.removeItem('candidateToken');
    localStorage.removeItem('candidateData');
    setCandidate(null);
  };

  const updateCandidate = (data) => {
    const updated = { ...candidate, ...data };
    setCandidate(updated);
    localStorage.setItem('candidateData', JSON.stringify(updated));
  };

  return (
    <AuthContext.Provider value={{
      admin, candidate, loading,
      adminLogin, adminRegister, adminLogout,
      candidateLogin, candidateLogout, updateCandidate
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
